import { render, staticRenderFns } from "./SMSListContainer.vue?vue&type=template&id=2655ac88&scoped=true"
import script from "./SMSListContainer.vue?vue&type=script&lang=js"
export * from "./SMSListContainer.vue?vue&type=script&lang=js"
import style0 from "./SMSListContainer.vue?vue&type=style&index=0&id=2655ac88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655ac88",
  null
  
)

export default component.exports